const API_BASE = '/api';

async function request(endpoint, options = {}) {
    const token = localStorage.getItem('token');

    const headers = {
        ...options.headers
    };

    if (token && token !== 'undefined' && token !== 'null') {
        headers.Authorization = `Bearer ${token}`;
    }

    // Don't set Content-Type for FormData (file uploads)
    if (!(options.body instanceof FormData)) {
        headers['Content-Type'] = 'application/json';
    }

    const response = await fetch(`${API_BASE}${endpoint}`, {
        ...options,
        headers
    });

    const contentType = response.headers.get('content-type');
    let data;

    if (contentType && contentType.includes('application/json')) {
        data = await response.json();
    } else {
        const text = await response.text();
        data = { message: text || 'Server returned an empty or non-JSON response' };
    }

    if (!response.ok) {
        throw new Error(data.message || data.error || `Request failed with status ${response.status}`);
    }

    return data;
}

// Template API
export const templateApi = {
    // Admin: List all. Operator: List active.
    list: (params = {}) => {
        const query = new URLSearchParams(params).toString();
        return request(`/templates${query ? `?${query}` : ''}`);
    },

    get: (id) => request(`/templates/${id}`),

    // Admin Only - Use secure endpoint
    upload: async (file, name, description) => {
        const formData = new FormData();
        formData.append('file', file);
        if (name) formData.append('name', name);
        if (description) formData.append('description', description);

        return request('/templates/upload', {
            method: 'POST',
            body: formData
        });
    },

    // Admin Only
    activate: (id) => request(`/templates/${id}/activate`, { method: 'POST' })
};

// Run API
export const runApi = {
    // Operator: Execute Template
    execute: (templateId, inputs) => request(`/runs/${templateId}`, {
        method: 'POST',
        body: JSON.stringify({ inputs })
    }),

    // History
    list: (params = {}) => {
        const query = new URLSearchParams(params).toString();
        return request(`/runs${query ? `?${query}` : ''}`);
    },

    get: (id) => request(`/runs/${id}`)
};

// Auth API
export const authApi = {
    // Support both email and username login
    login: (emailOrUsername, password) => {
        const isEmail = emailOrUsername.includes('@');
        const body = isEmail
            ? { email: emailOrUsername, password }
            : { username: emailOrUsername, password };

        return request('/auth/login', {
            method: 'POST',
            body: JSON.stringify(body)
        });
    },

    register: (email, username, password, orgName) => request('/auth/register', {
        method: 'POST',
        body: JSON.stringify({ email, username, password, orgName })
    }),

    me: () => request('/auth/me'),

    // Admin only
    listUsers: () => request('/auth/users'),
    updateUserRole: (id, role) => request(`/auth/users/${id}/role`, {
        method: 'PUT',
        body: JSON.stringify({ role })
    }),
    createUser: (email, username, password, role = 'operator') => request('/auth/users', {
        method: 'POST',
        body: JSON.stringify({ email, username, password, role })
    }),

    // Account management
    deleteAccount: () => request('/auth/delete-account', {
        method: 'DELETE'
    }),

    exportUserData: () => request('/auth/export-data', {
        method: 'GET'
    })
};

// Audit API
export const auditApi = {
    list: (params = {}) => {
        const query = new URLSearchParams(params).toString();
        return request(`/audit${query ? `?${query}` : ''}`);
    }
};

export default {
    auth: authApi,
    templates: templateApi,
    runs: runApi,
    audit: auditApi
};
